import {Component, ChangeDetectionStrategy} from "@angular/core";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzFormModule} from "ng-zorro-antd/form";
import {NzInputModule} from "ng-zorro-antd/input";
import {NzModalModule, NzModalRef} from "ng-zorro-antd/modal";
import {NzSpaceModule} from "ng-zorro-antd/space";

@Component({
    selector: "app-email-modal-content",
    standalone: true,
    imports: [
        NzFormModule,
        NzInputModule,
        ReactiveFormsModule,
        NzSpaceModule,
        FormsModule,
        NzButtonModule,
        NzSpaceModule,
        NzModalModule
    ],
    template: `
        <form nz-form [formGroup]="emailForm" nzLayout="vertical">
            <nz-form-item>
                <nz-form-label nzRequired>Email To</nz-form-label>
                <nz-form-control>
                    <input
                        nz-input
                        formControlName="to"
                        placeholder="Enter recipient email"
                        type="email"
                        maxlength="255" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label nzRequired>Email Subject</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="subject" placeholder="Enter subject" maxlength="255" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label nzRequired>Message</nz-form-label>
                <nz-form-control>
                    <textarea
                        nz-input
                        formControlName="message"
                        rows="8"
                        placeholder="Enter your message"
                        [maxlength]="maxLength">
                    </textarea>
                    <div class="character-counter">{{ messageLength }} / {{ maxLength }}</div>
                </nz-form-control>
            </nz-form-item>
        </form>
        <nz-space-compact nzSize="large">
            <button nz-button (click)="close()">Cancel</button>
            <button nz-button [disabled]="emailForm.invalid" nzType="primary" (click)="sendEmail()">Send Email</button>
        </nz-space-compact>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [
        `
            .character-counter {
                text-align: right;
                font-size: 12px;
                color: #999;
                margin-top: 4px;
            }
        `
    ]
})
export class EmailModalComponent {
    emailForm: FormGroup;
    messageLength = 0;
    maxLength = 1000;

    constructor(
        private modalRef: NzModalRef,
        private fb: FormBuilder
    ) {
        this.emailForm = this.fb.group({
            to: ["", [Validators.required, Validators.email]],
            subject: ["", Validators.required],
            message: ["", [Validators.required, Validators.maxLength(this.maxLength)]]
        });
        this.emailForm.get("message")?.valueChanges.subscribe(value => {
            this.messageLength = value ? value.length : 0;
        });
    }

    sendEmail(): void {
        if (this.emailForm.valid) {
            console.log("Email data:", this.emailForm.value);
            this.modalRef.close(this.emailForm.value); // Close modal and return data
        } else {
            Object.keys(this.emailForm.controls).forEach(key => {
                this.emailForm.get(key)?.markAsDirty();
            });
        }
    }

    close(): void {
        this.modalRef.close();
    }
}
